// Inspect global filter/search controllers to decide whether the incoming file batch
// represents an "empty query, no filters" view (which gates random shuffling).

const SEARCH_BOX_SELECTORS = [
    '#fnd_searchbox',
    'input[name="sq"]',
    'input[name="search"]'
];

const CATEGORY_GROUPS = ['L', 'F', 'M', 'S'];

// Read the current search query string from any of the known input boxes.
export function getSearchQuery() {
    try {
        for (const selector of SEARCH_BOX_SELECTORS) {
            const input = selector === '#fnd_searchbox'
                ? document.getElementById('fnd_searchbox')
                : document.querySelector(selector);
            if (input) {
                return (input.value || '').trim();
            }
        }
    } catch (_) {
        // Silent: DOM may not be ready yet.
    }
    return '';
}

// True if any category, date, format, or "public only" filter is active.
// Checks FilterController first (most up-to-date), falls back to FilterManager.
export function hasActiveFilters() {
    let active = false;

    try {
        if (window.filterController && typeof window.filterController.getSelectedCategories === 'function') {
            const categories = window.filterController.getSelectedCategories();
            if (categories && Object.keys(categories).length > 0) {
                for (const group of CATEGORY_GROUPS) {
                    if (Array.isArray(categories[group]) && categories[group].length > 0) {
                        active = true;
                        break;
                    }
                }
            }
        }

        if (!active && window.filterController && window.filterController.activeFilters) {
            const dateFrom = window.filterController.activeFilters.dateFrom || '';
            const dateTo = window.filterController.activeFilters.dateTo || '';
            if ((typeof dateFrom === 'string' && dateFrom.trim()) ||
                (typeof dateTo === 'string' && dateTo.trim())) {
                active = true;
            }
        }

        if (window.filterManager && window.filterManager.activeFilters) {
            const filters = window.filterManager.activeFilters;
            if (filters.category || filters.subcategory || filters.format) {
                active = true;
            }
            // Date filter fallback only if FilterController did not provide them.
            if (!active &&
                (!window.filterController || !window.filterController.activeFilters) &&
                (filters.dateFrom || filters.dateTo)) {
                active = true;
            }
            if (filters.publicOnly) {
                active = true;
            }
        }
    } catch (_) {
        // Silent: any controller may be partially initialized.
    }

    return active;
}

// Detect "search → empty query" transition so the orchestrator knows to reshuffle ALL files.
// Reads the previous query and the "query_was_cleared" flag set by FilterManager,
// updates session storage with the current query, and returns the boolean flag.
export function detectSearchTransition(searchQuery) {
    let wasSearchingBefore = false;
    try {
        const lastQuery = sessionStorage.getItem('lazy_load_last_query') || '';
        const queryWasCleared = sessionStorage.getItem('query_was_cleared') === 'true';
        const hadQueryBefore = lastQuery && lastQuery.trim().length > 0;
        const isEmptyNow = !searchQuery || !searchQuery.trim();
        wasSearchingBefore = (hadQueryBefore && isEmptyNow) || queryWasCleared;

        if (queryWasCleared) {
            sessionStorage.removeItem('query_was_cleared');
        }
        sessionStorage.setItem('lazy_load_last_query', searchQuery || '');
    } catch (_) {
        // Silent: sessionStorage may be unavailable (private mode, etc.).
    }
    return wasSearchingBefore;
}
